import { useAuth } from "@/providers/AuthProvider";
import { useTheme } from "@/providers/ThemeProvider";
import { RadixColor } from "@/types/breeze/Theme";
import { TenantRadius } from "@/types/breeze/Tenant";

export function useTenantTheme() {
  const { currentTenant } = useAuth();
  const { setPrimaryColor, setGrayColor, setRadius } = useTheme();

  const updateTenantPrimaryColor = (color: RadixColor) => {
    setPrimaryColor(color);
  };

  const updateTenantGrayColor = (
    color: "gray" | "mauve" | "slate" | "sage" | "olive" | "sand",
  ) => {
    setGrayColor(color);
  };

  const updateTenantRadius = (radius: TenantRadius) => {
    setRadius(radius);
  };

  const getCurrentPrimaryColor = (): RadixColor => {
    return currentTenant?.theme_settings?.primary_color || "orange";
  };

  const getCurrentGrayColor = ():
    | "gray"
    | "mauve"
    | "slate"
    | "sage"
    | "olive"
    | "sand" => {
    return currentTenant?.theme_settings?.gray_color || "gray";
  };

  const getCurrentRadius = (): TenantRadius => {
    return currentTenant?.theme_settings?.radius || "none";
  };

  return {
    updateTenantPrimaryColor,
    updateTenantGrayColor,
    updateTenantRadius,
    getCurrentPrimaryColor,
    getCurrentGrayColor,
    getCurrentRadius,
    tenantThemeSettings: currentTenant?.theme_settings,
  };
}
